import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio, Input, Checkbox } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { bindModelInfo } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class StubStatusUpdateClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isEmail:this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null ? (this.props.stubId.powerModelMessageCfg.isEmail == 1 ? true : false) : false,
      isTel:this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null ? (this.props.stubId.powerModelMessageCfg.isTel == 1 ? true : false) : false,
      internationalization: this.props.intl.messages.bindModelMessage,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          btnLoading: true,
        });
        if (this.props.isBatch && this.props.isBatch == 1) {
          values.meterModuleId = this.props.stubIds;
        } else {
          values.meterModuleId = this.props.stubId.meterModuleId;
        }
        
        values.isEmail = values.isEmail ? 1 : 2;
        values.isTel = values.isTel ? 1 : 2;
        if (values.isEmail == 2 && values.isTel == 2)
        {
          message.error("手机号或者邮箱请至少选择一个填写");
          this.setState({
            btnLoading: false,
          });
          return;
        }
        fetchHandler(bindModelInfo, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  onChangeTel = (e) => {
    this.setState({
      isTel: !this.state.isTel,
    });
  };
  onChangeEmail = (e) => {
    this.setState({
      isEmail: !this.state.isEmail,
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        
        <Form onSubmit={this.handleSubmit}>
          <div>
          
          <FormItem {...formItemLayout} label='推送方式'> 
            {getFieldDecorator("isEmail", {
              rules: [
                {
                  required: true,
                  message: this.state.internationalization.placeholder1, // "请选择要修改的状态"
                },
              ],
              initialValue: this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null && this.props.stubId.powerModelMessageCfg.isEmail != null ? (this.props.stubId.powerModelMessageCfg.isEmail == 1 ? true : false) : false,
            })(
              // <Radio.Group onChange={this.onChangeEmail}>
              //   <Radio key="1" value="1">是</Radio>
              //   <Radio key="2" value="2">否</Radio>
              // </Radio.Group>,
              <Checkbox defaultChecked={this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null && this.props.stubId.powerModelMessageCfg.isEmail != null ? (this.props.stubId.powerModelMessageCfg.isEmail == 1 ? true : false) : false} onChange={this.onChangeEmail}>邮件</Checkbox>
              )}
          </FormItem>
          </div>
          
          <FormItem {...formItemLayout} label='邮箱地址'>
              {getFieldDecorator("emailInfo", {
                rules: [
                  {
                    required: this.state.isEmail,
                    message: "请输入邮箱地址",
                  },
                ],
                initialValue: this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null ? this.props.stubId.powerModelMessageCfg.emailInfo : null,
              })(<Input disabled={!this.state.isEmail} placeholder='请输入邮箱地址'/>)}
            </FormItem>

            <FormItem {...formItemLayout} label='通知方式'>
            {getFieldDecorator("isTel", {
              rules: [
                {
                  required: true,
                  message: this.state.internationalization.placeholder1, // "请选择要修改的状态"
                },
              ],
              initialValue: this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null && this.props.stubId.powerModelMessageCfg.isTel != null ? (this.props.stubId.powerModelMessageCfg.isTel == 1 ? true : false) : false,
            })(
              // <Radio.Group onChange={this.onChangeTel}>
              //   <Radio key="1" value="1">是</Radio>
              //   <Radio key="2" value="2">否</Radio>
              // </Radio.Group>,
              <Checkbox defaultChecked={this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null && this.props.stubId.powerModelMessageCfg.isTel != null ? (this.props.stubId.powerModelMessageCfg.isTel == 1 ? true : false) : false} onChange={this.onChangeTel}>短信</Checkbox>
              )}
          </FormItem>

            <FormItem {...formItemLayout} label='手机号码'>
              {getFieldDecorator("telephone", {
                rules: [
                  {
                    required: this.state.isTel,
                    message: "请输入手机号码",
                  },
                ],
                initialValue: this.props.stubId != null && this.props.stubId.powerModelMessageCfg != null ? this.props.stubId.powerModelMessageCfg.telephone : null,
              })(<Input disabled={!this.state.isTel} placeholder='请输入手机号码'/>)}
            </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              保存
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const StubStatusUpdate = Form.create()(StubStatusUpdateClass);

export default injectIntl(StubStatusUpdate);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/powerBox/stubStatusUpdate.js